import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdConfigCheck from '../components/AdConfigCheck';
import Users from '../components/Users'
import MainLayout from "../components/MainLayout";

function Router() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <MainLayout>
            <AdConfigCheck />
          </MainLayout>
        } />
        <Route path="/loginCallback" element={
          <MainLayout>
            <AdConfigCheck />
          </MainLayout>
        } />
        <Route path="/Users" element={
          <MainLayout>
            <Users />
          </MainLayout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
